import { LastUsedSettings, MijnFeedbackSettings, RequiredMetadata } from '@ap/mijn-feedback';

export interface FeedbackConfiguration extends Pick<MijnFeedbackSettings, 'metadata'> {
    sidebarLabel: string;
    moodTitle: string;
    commentsTitle: string;
    configurationKey: string;
    requiredMetadata: RequiredMetadata;
    lastUsedSettings?: LastUsedSettings;
}

export interface MijnFeedbackForm {
    channelId: string;
    moodId: string;
    commentsId: string;
}

export const mijnFeedbackFormDefault: MijnFeedbackForm = {
    channelId: '',
    commentsId: '',
    moodId: ''
};

export enum TemplateVariant {
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}
